export const translations = {
  en: {
    hero: {
      eyebrow: 'Authentic Mexico:',
      eyebrowItalic: 'The Heritage Secrets',
      badge: 'Premium Digital Masterclass',
      h1: 'Stop Eating "Fake" Mexican Food. Start Cooking the Authentic Secrets.',
      h2: 'The 100% Traditional Recipe Map to Recreating Oaxaca, Tulum & Cabo Flavors Using Your Local U.S. Grocery Store.',
      trusted: '— Trusted by 8,427+ home cooks',
      cta: 'Get the authentic recipes now',
      instant: 'Instant Download',
      guarantee: '30-Day Guarantee',
      lifetime: 'Lifetime Access',
    },
    hook: {
      p1: "You remember that moment, don't you? Sitting by the turquoise water in Tulum or a cobblestone street in Oaxaca, tasting a mole or a fish taco that changed everything.",
      p2: 'But when you got home, your "Mexican night" felt flat. Generic. Like a cheap imitation from a yellow box. You thought you needed rare ingredients or three days of prep time.',
      wrong: 'You were wrong.',
    },
    problem: {
      title: 'The Problem',
      p1: 'The problem isn\'t your cooking skills. It\'s that most recipes are either "Americanized" junk or so complicated you need a professional kitchen to make them.',
      p2: 'You miss the authentic smoke, the silkiness of real mole, and the "glass-like" crunch of a Baja fish taco. You want paradise back on your dinner table, but you don\'t want to spend all weekend in the kitchen.',
    },
    whyFailed: {
      title: "Why What You Tried Didn't Work",
      items: [
        'Store-bought "taco kits" are loaded with sugar and cumin, tasting nothing like Mexico.',
        "YouTube recipes often require ingredients you can't find at Walmart or Kroger.",
        'Gourmet cookbooks assume you have 12 hours to simmer a sauce.',
        'Tex-Mex shortcuts rely on heavy yellow cheese that masks the real traditional flavors.',
      ],
    },
    mechanism: {
      title: 'The Unique Mechanism',
      subtitle: 'The Supermarket Swap Map™',
      p1: "We've decoded the recipes from Mexico's top 5-star resorts and translated them for the American kitchen. My Swap Map reveals chef-tested substitutions from your everyday supermarket — pantry items you'd never guess are the biological twins to Mexico's most guarded traditional ingredients.",
      highlight: '100% authentic taste. 0% struggle.',
    },
    whoFor: {
      titleFor: 'Who This Is For',
      itemsFor: [
        'Travelers who left a piece of their heart in a Mexican resort.',
        'Foodies tired of "yellow cheese" Tex-mex.',
        'Busy parents who want a 5-star dinner in 30 minutes.',
        "Anyone who shops at Walmart, Kroger, Trader Joe's, or Whole Foods.",
      ],
      titleNot: 'Who This Is NOT For',
      itemsNot: [
        'People who think Taco Bell is authentic.',
        'Professional chefs looking for 3-day fermentation recipes.',
        'Anyone not interested in bold, smoky, and vibrant flavors.',
      ],
    },
    howItWorks: {
      title: 'How It Works',
      steps: [
        {
          title: 'Download',
          desc: 'Get the PDF instantly on your phone or tablet.',
        },
        {
          title: 'Shop',
          desc: 'Use the Sourcing Guide at your local grocery store.',
        },
        {
          title: 'Cook',
          desc: 'Follow the "Resort Detail" steps for a guaranteed 5-star result.',
        },
      ],
    },
    offer: {
      hurry: 'Hurry! Limited Time Offer — 50% OFF',
      title: 'Bring Paradise Home Today.',
      desc: 'Stop settling for "fake" Mexican food. Get the authentic resort flavors you crave for less than the price of a single appetizer.',
      valued: 'VALUED AT $129 USD',
      save: 'SAVE $6.51',
      oneTime: 'USD — One-Time Payment',
      cta: 'Get the Resort Secrets Now',
      secure: 'Secure Digital Download. Start cooking in 5 minutes.',
      coffee:
        "🌿 This recipe book costs less than 3 coffees — but unlike caffeine that fades in less than an hour, the knowledge you'll gain will serve you for a lifetime. 🌱",
      ps: 'Remember, you\'re protected by our 30-day money-back guarantee. Download the playbook, cook three recipes, and if you don\'t taste paradise on your plate, email us for a full refund. The only thing you can lose is the fake "Mexican night."',
    },
    featuredIn: {
      title: 'As Featured In',
      stats: [
        { value: '8,427+', label: 'Happy Home Cooks' },
        { value: '12', label: 'Resort Recipes' },
        { value: '4.9 / 5', label: 'Average Rating' },
        { value: '30 Days', label: 'Money-Back Guarantee' },
      ],
    },
    aboutCreator: {
      badge: '5+ years of resort\nkitchen research',
      title: 'Meet Your Guide',
      p1: "Hi, I'm Isabella Romero. Like you, I fell in love with the vibrant, smoky, and complex flavors of authentic Mexican cuisine while traveling through Oaxaca, Tulum, and Cabo.",
      p2: "But when I returned to the US, I was frustrated. The recipes I found online either tasted like generic Tex-Mex or required me to hunt down rare ingredients that my local grocery store didn't carry. I wanted real resort-quality food without the hassle.",
      p3: 'So, I spent 5 summers traveling back to Mexico, stagiering in 3 different 5-star resort kitchens. I begged the local chefs to teach me their secrets, and then I spent years in my own kitchen decoding those traditional recipes for the American supermarket. The result is the "Swap Map" — your shortcut to authentic flavor.',
      role: 'Creator & Food Researcher',
    },
    recipeMenu: {
      badge: "What's Inside The Playbook",
      title: '12 Authentic Recipes from',
      titleItalic: '3 Iconic Regions',
      desc: "A curated culinary journey through Mexico's most beloved coastal and traditional kitchens.",
      region: 'Region',
      recipe: 'Recipe',
      footer: '4 Recipes · Full Sourcing Guide',
      oaxacaSub: 'The Soul of Mexican Cuisine',
      bajaSub: 'Coastal Pacific Flavors',
      tulumSub: 'The Maya Feast',
      bonusBadge: 'Sealed Bonus Section',
      bonusIncluded: '✓ Already included in the book — no extra cost',
      bonusTitle: '+ 2 Hidden Bonuses',
      bonusTitleItalic: 'Locked Inside',
      bonusDesc1:
        "Beyond the 12 region recipes, two more surprises are waiting for you between the pages. We can't reveal them here —",
      bonusDesc2: "they're only unlocked once you open the playbook.",
      hidden1Title: 'Hidden Recipe #13:',
      hidden1Desc: '??? — the one Isabella was sworn never to share',
      hidden2Title: 'The VIP Welcome Drink:',
      hidden2Desc: "??? — served only at Tulum's most exclusive beach club",
      curious: "Curious? There's only one way to find out.",
      unlockBtn: 'Unlock Bonuses',
    },
    samplePreview: {
      badge: 'Take a Peek Inside',
      title: "See What's Inside the Playbook",
      desc: 'Three sample pages from the 20-page masterclass — fully unlocked when you grab your copy.',
      unlock: '🔒 Unlock Full Recipe',
      page: 'Page',
      of: 'of',
      ch3: 'Chapter 3 · Oaxaca',
      ch3Title: 'Mole Negro de Oaxaca',
      ch3Desc:
        'The 7-chile secret + the peanut butter shortcut that fooled my chef mentor.',
      ch5: 'Chapter 5 · Baja',
      ch5Title: 'Glass-Batter Fish Tacos',
      ch5Desc:
        'The exact beer + flour ratio for the crackle every Baja chef hides.',
      ch8: 'Chapter 8 · Riviera Maya',
      ch8Title: 'Slow Cooker Cochinita Pibil',
      ch8Desc:
        'Mayan BBQ that simmers overnight — wake up to resort-quality meat.',
    },
    valueBreakdown: {
      title: 'Everything You Get Today',
      bundle: 'The Resort Secrets Bundle',
      item1: 'The 20-Page Resort Secrets Playbook',
      item2: '12 Masterclass Recipes (Oaxaca/Baja/Riviera Maya)',
      item3: 'The Supermarket Sourcing Guide',
      item4: 'The "3-2-1" Resort Mixology Guide',
      item5: 'The Slow Cooker Pibil Hack',
      bonus1: 'BONUS #1: 7-Day Mexican Meal Plan',
      bonus2: 'BONUS #2: The Hidden 13th Recipe 🔒',
      bonus2Desc:
        'Sealed inside the playbook — only revealed once you open page 18.',
      bonus3: 'BONUS #3: The Secret Resort Welcome Drink 🍹',
      bonus3Desc:
        "The untold cocktail served only to VIP guests at Tulum's most exclusive beach club — recipe inside.",
      included: 'Included',
      free: 'FREE',
      totalValue: 'Total Value:',
      todayPrice: "Today's Price:",
    },
    comparison: {
      title: 'Why Pay More for Less?',
      desc: 'One playbook replaces the trip, the class, and the trial-and-error.',
      thisBook: 'This Book',
      restaurant: 'Restaurant',
      cookbook: 'Cookbook',
      class: 'Cooking Class',
      row1: 'Authentic resort flavors',
      row2: 'Cook from your home kitchen',
      row3: 'Ingredients from any US grocery store',
      row4: 'Ready in 30–45 minutes',
      row5: '30-day money-back guarantee',
      row6: 'Lifetime access — cook it forever',
    },
    testimonials: {
      title: 'Real Travelers, Real Resort Flavors',
      desc: 'Join thousands of home cooks bringing paradise to their dinner tables.',
      verified: 'Verified Buyer',
      t1: "I made the Oaxacan mole last weekend and my husband — who lived in Mexico City for 3 years — said it was the most authentic he's had outside Mexico. The peanut butter swap blew my mind.",
      t2: "Finally, a cookbook that doesn't require me to order $50 worth of dried chiles online. I found everything at my local Kroger and the Baja fish tacos were crispier than the ones we had in Cabo.",
      t3: "The slow cooker Pibil hack is a lifesaver for busy weeknights. It tastes like it's been roasting underground for 12 hours, but it took me 15 minutes of prep before work.",
      t4: "I was skeptical about the mixology guide, but the Mezcalita recipe alone is worth the price. It's exactly what we drank at our honeymoon resort in the Riviera Maya.",
    },
    guarantee: {
      title: '30-Day "Taste Paradise or It\'s Free" Guarantee',
      desc1:
        "Cook 3 recipes from the playbook. If you don't taste paradise on your plate, email us within 30 days for a full refund — and",
      desc2: 'keep the PDF anyway as our gift',
      desc3: '. No questions, no hoops.',
      badge: "You can't lose. We take all the risk.",
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'Do I need a specialty Mexican market?',
      a1: 'No. Every recipe is designed using ingredients available at major U.S. chains.',
      q2: 'Is the food too spicy?',
      a2: 'You control the heat. We show you how to get the flavor of the chiles without the burn.',
      q3: 'Is it a physical book?',
      a3: 'It is a high-resolution Digital PDF. You get it instantly after purchase.',
      q4: 'What devices can I open the PDF on?',
      a4: 'Any device! You can open it on your phone, tablet, computer, or Kindle.',
      q5: 'Can I print the recipes?',
      a5: 'Yes, the PDF includes print-friendly formatting so you can easily print your favorite recipes.',
      q6: 'How long do the recipes take?',
      a6: 'Most recipes take under 45 minutes. The slow cooker recipes do the work while you sleep or work.',
      q7: 'Are there gluten-free / dairy-free options?',
      a7: 'Yes, every recipe includes substitution notes for gluten-free and dairy-free diets.',
      q8: "What if I don't like it?",
      a8: 'We offer a 30-day money-back guarantee. No questions asked.',
      q9: 'Is there a Spanish version?',
      a9: 'Currently, the book is in English only, but all original Mexican recipe names are preserved.',
      q10: 'How quickly do I get access?',
      a10: 'Instantly after purchase! The download link is delivered straight to your email.',
    },
    trustBadges: {
      ssl: 'SSL Encrypted',
      sslDesc: 'Secure Checkout',
      cards: 'All Major Cards',
      cardsDesc: 'Visa · Mastercard · Amex',
      access: 'Instant Access',
      accessDesc: 'Delivered to your email',
      guarantee: '30-Day Guarantee',
      guaranteeDesc: '100% Risk-Free',
      accept: 'We Accept',
      secure: 'Secure payment with',
    },
    footer: {
      rights: 'Authentic Mexico: The Resort Secrets. All rights reserved.',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      changeLang: 'Change Language · Cambiar Idioma',
      termsContent: {
        title: 'Terms of Service',
        lastUpdated: 'Last updated:',
        h1: '1. Acceptance of Terms',
        p1: 'By purchasing and downloading Authentic Mexico: The Resort Secrets, you agree to these Terms of Service. If you do not agree, please do not complete your purchase.',
        h2: '2. Digital Product',
        p2: 'This product is a digital PDF download. Upon successful payment, you will receive instant access to the file. No physical product will be shipped.',
        h3: '3. License & Personal Use',
        p3: 'You are granted a non-transferable, non-exclusive license to use this PDF for personal cooking and home use only. You may not resell, redistribute, copy, share, or publish any part of this content without written permission.',
        h4: '4. Refund Policy',
        p4: 'We offer a 30-day money-back guarantee. If you are not satisfied with your purchase for any reason, contact us within 30 days of purchase and we will issue a full refund. No questions asked.',
        h5: '5. Disclaimer',
        p5: 'The recipes and ingredient substitutions provided are for informational purposes. We are not responsible for allergic reactions, dietary issues, or any health-related concerns arising from preparing or consuming the recipes. Always check ingredients for personal allergens.',
        h6: '6. Intellectual Property',
        p6: 'All recipes, photography, design, and written content are protected by copyright. Unauthorized reproduction or distribution is strictly prohibited.',
        h7: '7. Changes to Terms',
        p7: 'We reserve the right to modify these Terms at any time. Continued use of the product after changes constitutes acceptance of the updated Terms.',
      },
      privacyContent: {
        title: 'Privacy Policy',
        h1: '1. Information We Collect',
        p1: 'When you purchase Authentic Mexico: The Resort Secrets, we collect only the information necessary to fulfill your order, including your name, email address, and payment details (processed securely by our payment provider).',
        h2: '2. How We Use Your Information',
        p2: 'Your information is used solely to:',
        l2a: 'Process your purchase and deliver the digital PDF.',
        l2b: 'Send you a receipt and download link.',
        l2c: 'Send occasional product updates or new recipe releases (you may unsubscribe at any time).',
        h3: '3. Payment Security',
        p3: 'All payments are processed through trusted, PCI-compliant third-party providers. We do not store your credit card or payment details on our servers.',
        h4: '4. Cookies & Analytics',
        p4: 'We may use cookies and basic analytics tools to understand site usage and improve your experience. These tools do not collect personally identifiable information unless you provide it.',
        h5: '5. Sharing of Information',
        p5: 'We never sell, rent, or trade your personal information. Data is only shared with service providers (e.g. payment processor, email delivery) strictly to fulfill your order.',
        h6: '6. Your Rights',
        p6: 'You may request access to, correction of, or deletion of your personal data at any time. You may also opt out of marketing communications using the unsubscribe link in any email.',
        h7: '7. Data Retention',
        p7: 'We retain your purchase information only as long as necessary for legal, tax, and customer service purposes.',
        h8: '8. Changes to This Policy',
        p8: 'This Privacy Policy may be updated periodically. The latest version will always be available on this page.',
      },
    },
    stickyCTA: {
      getItNow: 'Get It Now',
    },
    liveActivity: {
      from: 'from',
      purchased: 'Just purchased',
      minAgo: 'min ago',
    },
    exitPopup: {
      wait: "Wait — Don't Leave Yet",
      lose1: "You're About to Lose",
      lose2: '50% OFF',
      desc1: 'Your discount of',
      desc2: '$6.51 OFF',
      desc3:
        'expires the moment you leave this page. After that, the price goes back to',
      limited: 'Limited Time Only',
      claim: 'Claim My 50% Discount',
      noThanks: "No thanks, I'll pay full price later",
    },
    countdown: {
      endsIn: 'Offer Ends In',
      hours: 'Hours',
      min: 'Min',
      sec: 'Sec',
    },
    video: {
      soundOn: 'Turn Your Sound On',
      title1: "Watch How Isabella Recreated Oaxaca's Best Mole",
      title2: 'Using Only Walmart Ingredients',
      watch: '▶ Watch the 2-minute demo',
      live: '● LIVE',
      placeholder: 'Video player placeholder',
      embed: 'Embed your VSL here (YouTube, Vimeo, or Wistia)',
      time: '⏱ Just 2 minutes — see the full transformation before you decide.',
    },
  },
  es: {
    hero: {
      eyebrow: 'Authentic Mexico:',
      eyebrowItalic: 'The Heritage Secrets',
      badge: 'Masterclass Digital Premium',
      h1: 'Deja de comer comida mexicana "falsa". Empieza a cocinar los secretos auténticos.',
      h2: 'El mapa de recetas 100% tradicionales para recrear los sabores de Oaxaca, Tulum y Cabo usando tu supermercado local.',
      trusted: '— Confiado por más de 8,427 cocineros caseros',
      cta: 'Obtén las recetas auténticas ahora',
      instant: 'Descarga Instantánea',
      guarantee: 'Garantía de 30 Días',
      lifetime: 'Acceso de por Vida',
    },
    hook: {
      p1: '¿Recuerdas ese momento, verdad? Sentado junto al agua turquesa en Tulum o en una calle empedrada de Oaxaca, probando un mole o un taco de pescado que lo cambió todo.',
      p2: 'Pero cuando llegaste a casa, tu "noche mexicana" se sintió plana. Genérica. Como una imitación barata de una caja amarilla. Pensaste que necesitabas ingredientes raros o tres días de preparación.',
      wrong: 'Estabas equivocado.',
    },
    problem: {
      title: 'El Problema',
      p1: 'El problema no son tus habilidades culinarias. Es que la mayoría de las recetas son basura "americanizada" o tan complicadas que necesitas una cocina profesional para hacerlas.',
      p2: 'Extrañas el humo auténtico, la sedosidad del mole real y el crujido "como cristal" de un taco de pescado estilo Baja. Quieres que el paraíso vuelva a tu mesa, pero no quieres pasar todo el fin de semana en la cocina.',
    },
    whyFailed: {
      title: 'Por Qué lo que Intentaste No Funcionó',
      items: [
        'Los "kits de tacos" del supermercado están llenos de azúcar y comino, sin saber a nada parecido a México.',
        'Las recetas de YouTube a menudo requieren ingredientes que no puedes encontrar en Walmart o Kroger.',
        'Los libros de cocina gourmet asumen que tienes 12 horas para cocinar a fuego lento una salsa.',
        'Los atajos Tex-Mex dependen de queso amarillo pesado que oculta los verdaderos sabores tradicionales.',
      ],
    },
    mechanism: {
      title: 'El Mecanismo Único',
      subtitle: 'El Mapa de Intercambio de Supermercado™',
      p1: 'Hemos decodificado las recetas de los mejores resorts de 5 estrellas de México y las hemos traducido para la cocina estadounidense. Mi Mapa de Intercambio revela sustituciones probadas por chefs desde tu supermercado diario — artículos de despensa que nunca adivinarías que son los gemelos biológicos de los ingredientes tradicionales más guardados de México.',
      highlight: '100% sabor auténtico. 0% complicaciones.',
    },
    whoFor: {
      titleFor: 'Para Quién Es Esto',
      itemsFor: [
        'Viajeros que dejaron un pedazo de su corazón en un resort mexicano.',
        'Amantes de la comida cansados del Tex-Mex de "queso amarillo".',
        'Padres ocupados que quieren una cena de 5 estrellas en 30 minutos.',
        "Cualquiera que compre en Walmart, Kroger, Trader Joe's o Whole Foods.",
      ],
      titleNot: 'Para Quién NO Es Esto',
      itemsNot: [
        'Personas que piensan que Taco Bell es auténtico.',
        'Chefs profesionales que buscan recetas de fermentación de 3 días.',
        'Cualquiera que no esté interesado en sabores audaces, ahumados y vibrantes.',
      ],
    },
    howItWorks: {
      title: 'Cómo Funciona',
      steps: [
        {
          title: 'Descarga',
          desc: 'Obtén el PDF al instante en tu teléfono o tablet.',
        },
        {
          title: 'Compra',
          desc: 'Usa la Guía de Compras en tu supermercado local.',
        },
        {
          title: 'Cocina',
          desc: 'Sigue los pasos de "Detalle de Resort" para un resultado garantizado de 5 estrellas.',
        },
      ],
    },
    offer: {
      hurry: '¡Rápido! Oferta por Tiempo Limitado — 50% de Descuento',
      title: 'Trae el Paraíso a Casa Hoy.',
      desc: 'Deja de conformarte con comida mexicana "falsa". Obtén los auténticos sabores de resort que anhelas por menos del precio de un solo aperitivo.',
      valued: 'VALORADO EN $129 USD',
      save: 'AHORRA $6.51',
      oneTime: 'USD — Pago Único',
      cta: 'Obtén los Secretos de los Resorts Ahora',
      secure: 'Descarga Digital Segura. Empieza a cocinar en 5 minutos.',
      coffee:
        '🌿 Este recetario cuesta menos que 3 cafés — pero a diferencia de la cafeína que se desvanece en menos de una hora, el conocimiento que obtendrás te servirá para toda la vida. 🌱',
      ps: 'Recuerda, estás protegido por nuestra garantía de devolución de dinero de 30 días. Descarga el manual, cocina tres recetas, y si no pruebas el paraíso en tu plato, envíanos un correo para un reembolso completo. Lo único que puedes perder es la falsa "noche mexicana".',
    },
    featuredIn: {
      title: 'Como se vio en',
      stats: [
        { value: '8,427+', label: 'Cocineros Felices' },
        { value: '12', label: 'Recetas de Resort' },
        { value: '4.9 / 5', label: 'Calificación Promedio' },
        { value: '30 Días', label: 'Garantía de Reembolso' },
      ],
    },
    aboutCreator: {
      badge: 'Más de 5 años de investigación\nen cocinas de resorts',
      title: 'Conoce a tu Guía',
      p1: 'Hola, soy Isabella Romero. Al igual que tú, me enamoré de los sabores vibrantes, ahumados y complejos de la auténtica cocina mexicana mientras viajaba por Oaxaca, Tulum y Cabo.',
      p2: 'Pero cuando regresé a EE. UU., me sentí frustrada. Las recetas que encontré en línea sabían a Tex-Mex genérico o requerían que buscara ingredientes raros que mi supermercado local no tenía. Quería comida real con calidad de resort sin las molestias.',
      p3: 'Así que pasé 5 veranos viajando de regreso a México, haciendo prácticas en 3 diferentes cocinas de resorts de 5 estrellas. Rogué a los chefs locales que me enseñaran sus secretos, y luego pasé años en mi propia cocina decodificando esas recetas tradicionales para el supermercado estadounidense. El resultado es el "Mapa de Intercambio" — tu atajo hacia el sabor auténtico.',
      role: 'Creadora e Investigadora Gastronómica',
    },
    recipeMenu: {
      badge: 'Qué Hay Dentro del Manual',
      title: '12 Recetas Auténticas de',
      titleItalic: '3 Regiones Icónicas',
      desc: 'Un viaje culinario curado a través de las cocinas costeras y tradicionales más queridas de México.',
      region: 'Región',
      recipe: 'Receta',
      footer: '4 Recetas · Guía de Compras Completa',
      oaxacaSub: 'El Alma de la Cocina Mexicana',
      bajaSub: 'Sabores Costeros del Pacífico',
      tulumSub: 'El Festín Maya',
      bonusBadge: 'Sección de Bonos Sellada',
      bonusIncluded: '✓ Ya incluidos en el libro — sin costo extra',
      bonusTitle: '+ 2 Bonos Ocultos',
      bonusTitleItalic: 'Encerrados Adentro',
      bonusDesc1:
        'Más allá de las 12 recetas regionales, dos sorpresas más te esperan entre las páginas. No podemos revelarlas aquí —',
      bonusDesc2: 'solo se desbloquean una vez que abres el manual.',
      hidden1Title: 'Receta Oculta #13:',
      hidden1Desc: '??? — la que Isabella juró nunca compartir',
      hidden2Title: 'La Bebida de Bienvenida VIP:',
      hidden2Desc:
        '??? — servida solo en el club de playa más exclusivo de Tulum',
      curious: '¿Curioso? Solo hay una forma de averiguarlo.',
      unlockBtn: 'Desbloquear Bonos',
    },
    samplePreview: {
      badge: 'Echa un Vistazo Adentro',
      title: 'Mira lo que Hay Dentro del Manual',
      desc: 'Tres páginas de muestra de la masterclass de 20 páginas — totalmente desbloqueadas cuando obtienes tu copia.',
      unlock: '🔒 Desbloquear Receta Completa',
      page: 'Página',
      of: 'de',
      ch3: 'Capítulo 3 · Oaxaca',
      ch3Title: 'Mole Negro de Oaxaca',
      ch3Desc:
        'El secreto de los 7 chiles + el atajo de la mantequilla de maní que engañó a mi chef mentor.',
      ch5: 'Capítulo 5 · Baja',
      ch5Title: 'Tacos de Pescado con Masa de Cristal',
      ch5Desc:
        'La proporción exacta de cerveza + harina para el crujido que todo chef de Baja esconde.',
      ch8: 'Capítulo 8 · Riviera Maya',
      ch8Title: 'Cochinita Pibil en Olla de Cocción Lenta',
      ch8Desc:
        'Barbacoa Maya que hierve a fuego lento toda la noche — despierta con carne de calidad de resort.',
    },
    valueBreakdown: {
      title: 'Todo lo que Obtienes Hoy',
      bundle: 'El Paquete de Secretos de Resort',
      item1: 'El Manual de Secretos de Resort de 20 Páginas',
      item2: '12 Recetas Masterclass (Oaxaca/Baja/Riviera Maya)',
      item3: 'La Guía de Compras de Supermercado',
      item4: 'La Guía de Mixología "3-2-1" de Resort',
      item5: 'El Truco de Pibil en Olla de Cocción Lenta',
      bonus1: 'BONO #1: Plan de Comidas Mexicanas de 7 Días',
      bonus2: 'BONO #2: La Receta Oculta #13 🔒',
      bonus2Desc:
        'Sellada dentro del manual — solo se revela una vez que abres la página 18.',
      bonus3: 'BONO #3: La Bebida Secreta de Bienvenida del Resort 🍹',
      bonus3Desc:
        'El cóctel no contado servido solo a los huéspedes VIP en el club de playa más exclusivo de Tulum — receta adentro.',
      included: 'Incluido',
      free: 'GRATIS',
      totalValue: 'Valor Total:',
      todayPrice: 'Precio de Hoy:',
    },
    comparison: {
      title: '¿Por Qué Pagar Más por Menos?',
      desc: 'Un manual reemplaza el viaje, la clase y el ensayo y error.',
      thisBook: 'Este Libro',
      restaurant: 'Restaurante',
      cookbook: 'Libro de Cocina',
      class: 'Clase de Cocina',
      row1: 'Auténticos sabores de resort',
      row2: 'Cocina desde la cocina de tu casa',
      row3: 'Ingredientes de cualquier supermercado de EE. UU.',
      row4: 'Listo en 30–45 minutos',
      row5: 'Garantía de devolución de dinero de 30 días',
      row6: 'Acceso de por vida — cocínalo para siempre',
    },
    testimonials: {
      title: 'Viajeros Reales, Sabores de Resort Reales',
      desc: 'Únete a miles de cocineros caseros que llevan el paraíso a sus mesas.',
      verified: 'Comprador Verificado',
      t1: 'Hice el mole oaxaqueño el fin de semana pasado y mi esposo — quien vivió en la Ciudad de México por 3 años — dijo que era el más auténtico que ha probado fuera de México. El intercambio de mantequilla de maní me voló la cabeza.',
      t2: 'Finalmente, un libro de cocina que no requiere que ordene $50 en chiles secos en línea. Encontré todo en mi Kroger local y los tacos de pescado estilo Baja estaban más crujientes que los que comimos en Cabo.',
      t3: 'El truco del Pibil en olla de cocción lenta es un salvavidas para las noches ocupadas de la semana. Sabe como si hubiera estado asándose bajo tierra durante 12 horas, pero me tomó 15 minutos de preparación antes del trabajo.',
      t4: 'Era escéptico sobre la guía de mixología, pero solo la receta de la Mezcalita vale el precio. Es exactamente lo que bebimos en nuestro resort de luna de miel en la Riviera Maya.',
    },
    guarantee: {
      title: 'Garantía de 30 Días "Prueba el Paraíso o es Gratis"',
      desc1:
        'Cocina 3 recetas del manual. Si no pruebas el paraíso en tu plato, envíanos un correo electrónico dentro de los 30 días para un reembolso completo — y',
      desc2: 'quédate con el PDF de todos modos como nuestro regalo',
      desc3: '. Sin preguntas, sin aros por los que saltar.',
      badge: 'No puedes perder. Nosotros asumimos todo el riesgo.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      q1: '¿Necesito un mercado mexicano especializado?',
      a1: 'No. Cada receta está diseñada usando ingredientes disponibles en las principales cadenas de EE. UU.',
      q2: '¿La comida es muy picante?',
      a2: 'Tú controlas el picante. Te mostramos cómo obtener el sabor de los chiles sin el ardor.',
      q3: '¿Es un libro físico?',
      a3: 'Es un PDF digital de alta resolución. Lo obtienes al instante después de la compra.',
      q4: '¿En qué dispositivos puedo abrir el PDF?',
      a4: '¡En cualquier dispositivo! Puedes abrirlo en tu teléfono, tablet, computadora o Kindle.',
      q5: '¿Puedo imprimir las recetas?',
      a5: 'Sí, el PDF incluye un formato amigable para imprimir para que puedas imprimir fácilmente tus recetas favoritas.',
      q6: '¿Cuánto tiempo toman las recetas?',
      a6: 'La mayoría de las recetas toman menos de 45 minutos. Las recetas de olla de cocción lenta hacen el trabajo mientras duermes o trabajas.',
      q7: '¿Hay opciones sin gluten / sin lácteos?',
      a7: 'Sí, cada receta incluye notas de sustitución para dietas sin gluten y sin lácteos.',
      q8: '¿Qué pasa si no me gusta?',
      a8: 'Ofrecemos una garantía de devolución de dinero de 30 días. Sin hacer preguntas.',
      q9: '¿Hay una versión en español?',
      a9: 'Actualmente, el libro está solo en inglés, pero se conservan todos los nombres originales de las recetas mexicanas.',
      q10: '¿Qué tan rápido obtengo acceso?',
      a10: '¡Al instante después de la compra! El enlace de descarga se entrega directamente a tu correo electrónico.',
    },
    trustBadges: {
      ssl: 'Cifrado SSL',
      sslDesc: 'Pago Seguro',
      cards: 'Todas las Tarjetas',
      cardsDesc: 'Visa · Mastercard · Amex',
      access: 'Acceso Instantáneo',
      accessDesc: 'Entregado a tu correo',
      guarantee: 'Garantía de 30 Días',
      guaranteeDesc: '100% Libre de Riesgo',
      accept: 'Aceptamos',
      secure: 'Pago seguro con',
    },
    footer: {
      rights:
        'Authentic Mexico: The Resort Secrets. Todos los derechos reservados.',
      terms: 'Términos de Servicio',
      privacy: 'Política de Privacidad',
      changeLang: 'Change Language · Cambiar Idioma',
      termsContent: {
        title: 'Términos de Servicio',
        lastUpdated: 'Última actualización:',
        h1: '1. Aceptación de los Términos',
        p1: 'Al comprar y descargar Authentic Mexico: The Resort Secrets, aceptas estos Términos de Servicio. Si no estás de acuerdo, por favor no completes tu compra.',
        h2: '2. Producto Digital',
        p2: 'Este producto es una descarga digital en PDF. Tras el pago exitoso, recibirás acceso instantáneo al archivo. No se enviará ningún producto físico.',
        h3: '3. Licencia y Uso Personal',
        p3: 'Se te otorga una licencia intransferible y no exclusiva para usar este PDF solo para cocina personal y uso doméstico. No puedes revender, redistribuir, copiar, compartir o publicar ninguna parte de este contenido sin permiso por escrito.',
        h4: '4. Política de Reembolso',
        p4: 'Ofrecemos una garantía de devolución de dinero de 30 días. Si no estás satisfecho con tu compra por cualquier motivo, contáctanos dentro de los 30 días posteriores a la compra y emitiremos un reembolso completo. Sin hacer preguntas.',
        h5: '5. Descargo de Responsabilidad',
        p5: 'Las recetas y sustituciones de ingredientes proporcionadas son solo para fines informativos. No somos responsables de reacciones alérgicas, problemas dietéticos o cualquier problema relacionado con la salud que surja de la preparación o el consumo de las recetas. Siempre revisa los ingredientes para alérgenos personales.',
        h6: '6. Propiedad Intelectual',
        p6: 'Todas las recetas, fotografías, diseño y contenido escrito están protegidos por derechos de autor. La reproducción o distribución no autorizada está estrictamente prohibida.',
        h7: '7. Cambios a los Términos',
        p7: 'Nos reservamos el derecho de modificar estos Términos en cualquier momento. El uso continuo del producto después de los cambios constituye la aceptación de los Términos actualizados.',
      },
      privacyContent: {
        title: 'Política de Privacidad',
        h1: '1. Información que Recopilamos',
        p1: 'Cuando compras Authentic Mexico: The Resort Secrets, recopilamos solo la información necesaria para cumplir con tu pedido, incluyendo tu nombre, dirección de correo electrónico y detalles de pago (procesados de forma segura por nuestro proveedor de pagos).',
        h2: '2. Cómo Usamos tu Información',
        p2: 'Tu información se usa únicamente para:',
        l2a: 'Procesar tu compra y entregar el PDF digital.',
        l2b: 'Enviarte un recibo y un enlace de descarga.',
        l2c: 'Enviarte actualizaciones ocasionales del producto o nuevos lanzamientos de recetas (puedes darte de baja en cualquier momento).',
        h3: '3. Seguridad de Pago',
        p3: 'Todos los pagos se procesan a través de proveedores externos confiables y que cumplen con PCI. No almacenamos los detalles de tu tarjeta de crédito o pago en nuestros servidores.',
        h4: '4. Cookies y Análisis',
        p4: 'Podemos usar cookies y herramientas de análisis básicas para comprender el uso del sitio y mejorar tu experiencia. Estas herramientas no recopilan información de identificación personal a menos que tú la proporciones.',
        h5: '5. Intercambio de Información',
        p5: 'Nunca vendemos, alquilamos ni intercambiamos tu información personal. Los datos solo se comparten con proveedores de servicios (ej. procesador de pagos, entrega de correo electrónico) estrictamente para cumplir con tu pedido.',
        h6: '6. Tus Derechos',
        p6: 'Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento. También puedes optar por no recibir comunicaciones de marketing utilizando el enlace para darse de baja en cualquier correo electrónico.',
        h7: '7. Retención de Datos',
        p7: 'Retenemos la información de tu compra solo el tiempo necesario para fines legales, fiscales y de servicio al cliente.',
        h8: '8. Cambios a Esta Política',
        p8: 'Esta Política de Privacidad puede actualizarse periódicamente. La última versión siempre estará disponible en esta página.',
      },
    },
    stickyCTA: {
      getItNow: 'Obtener Ahora',
    },
    liveActivity: {
      from: 'de',
      purchased: 'Acaba de comprar',
      minAgo: 'min atrás',
    },
    exitPopup: {
      wait: 'Espera — No te Vayas Aún',
      lose1: 'Estás a Punto de Perder',
      lose2: '50% DE DESCUENTO',
      desc1: 'Tu descuento de',
      desc2: '$6.51 DLS',
      desc3:
        'expira en el momento en que salgas de esta página. Después de eso, el precio vuelve a',
      limited: 'Solo por Tiempo Limitado',
      claim: 'Reclamar Mi 50% de Descuento',
      noThanks: 'No gracias, pagaré el precio completo después',
    },
    countdown: {
      endsIn: 'La Oferta Termina En',
      hours: 'Horas',
      min: 'Min',
      sec: 'Seg',
    },
    video: {
      soundOn: 'Enciende tu Sonido',
      title1: 'Mira Cómo Isabella Recreó el Mejor Mole de Oaxaca',
      title2: 'Usando Solo Ingredientes de Walmart',
      watch: '▶ Mira la demo de 2 minutos',
      live: '● EN VIVO',
      placeholder: 'Marcador de posición del reproductor de video',
      embed: 'Incrusta tu VSL aquí (YouTube, Vimeo o Wistia)',
      time: '⏱ Solo 2 minutos — mira la transformación completa antes de decidir.',
    },
  },
}
